import { normalizeAuthority } from "../utils/authority/Authority.js";




export function onInsert(response, entity, data) {
    
    switch (entity){
        case 'user': {
            if(response.success !== 1) return;
            if(!data?.idAuthority?.id) return;
            if(!response?.id) return;

            normalizeAuthority(response?.id);

            break;
        }
    };

}